import { z } from "zod";
export const listTenantsQuerySchema = z.object({
    search: z.string().trim().min(1).optional(),
});
